import { Grid } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import ToolTip from '../../components/Tooltip/Tooltip';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import classes from './Scanit.module.css';
import TotalScanits from './components/totalScanits';
import ScanitAccuracy from './components/scanitAccuracy';
import BarChartScanit from './components/barChartScanit';

const Scanit = () => {
	//Filters
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		const dateFormat = [year, month, day].join('-');
		return dateFormat.toString();
	}

	const firstDateFilter = new Date();
	const date1 = formatDate(firstDateFilter.setMonth(firstDateFilter.getMonth() - 6));

	const secondDateFilter = new Date();
	const date2 = formatDate(secondDateFilter.setMonth(secondDateFilter.getMonth()));

	//Filters
	const [moneda, setMoneda] = useState('Todas');
	const [initialDate, setInitialDate] = useState(date1);
	const [endDate, setEndDate] = useState(date2);

	//Apis
	const [scanitReportActualUrl, setScanitReportActualUrl] = useState(
		`/getScanitsApprovedByMonth?dateFrom=${date1}&dateTo=${date2}&moneda=${moneda}`,
	);
	const [scanitReportTotalUrl, setScanitReportTotalUrl] = useState(`/getTotalScanitsByMonth?dateFrom=${date1}&dateTo=${date2}&moneda=${moneda}`);
	const [scanitAccuracyUrl, setScanitAccuracyUrl] = useState(`/getScanitAccuracy?date=${date2}`);

	//Data
	const [scanitReportingData, setScanitReportingData] = useState([]);
	const [scanitActualData, setScanitActualData] = useState({});
	const [totalScanitsByMonth, setTotalScanitsByMonth] = useState([]);
	const [totalScanitActualData, setTotalScanitActualData] = useState({});
	const [scanitAccuracy, setScanitAccuracy] = useState({});

	//Aux
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);

			await Axios.all([Axios.get(scanitReportActualUrl), Axios.get(scanitReportTotalUrl), Axios.get(scanitAccuracyUrl)]).then(
				Axios.spread((obj1, obj2, obj3) => {
					const lengthDataApproved = obj1.data.length;
					const lengthTotalScanits = obj2.data.length;

					try {
						setScanitReportingData(obj1.data);
						setScanitActualData(obj1.data[lengthDataApproved - 1]);
						setTotalScanitsByMonth(obj2.data);
						setTotalScanitActualData(obj2.data[lengthTotalScanits - 1]);
						setScanitAccuracy(obj3.data);
					} catch (error) {
						setIsError(true);
					}
					setIsLoading(false);
				}),
			);
		};
		fetchData();
	}, [scanitReportActualUrl, scanitReportTotalUrl, scanitAccuracyUrl]);

	return (
		<Fragment>
			<div className={classes.cardFilter}>
				<Grid container direction="row" justify="center" alignItems="center">
					<div className={classes.formup}>
						<form
							onSubmit={(event) => {
								setScanitReportActualUrl(`/getScanitsApprovedByMonth??dateFrom=${initialDate}&dateTo=${endDate}&moneda=${moneda}`);
								setScanitReportTotalUrl(`/getTotalScanitsByMonth?dateFrom=${initialDate}&dateTo=${endDate}&moneda=${moneda}`);
								setScanitAccuracyUrl(`/getScanitAccuracy?date=${endDate}`);

								event.preventDefault();
							}}
						>
							<Grid container spacing={2}>
								<div>
									<select value={moneda} onChange={(event) => setMoneda(event.target.value)}>
										<option value={'Todas'}>Todos las Monedas</option>
										<option value={'CLP'}>CLP</option>
										<option value={'PEN'}>PEN</option>
										<option value={'ARS'}>ARS</option>
									</select>
								</div>

								<div>
									<input type="date" id="dateDesde" value={initialDate} onChange={(event) => setInitialDate(event.target.value)} />
								</div>

								<div>
									<input type="date" id="dateHasta" defaultValue={endDate} onChange={(event) => setEndDate(event.target.value)} />
								</div>

								<div>
									<input className={classes.buttonRindegastos} type="submit" value="Filtrar" />
								</div>
								{isError && <div>Ups! Algo salió mal...</div>}
							</Grid>
						</form>
					</div>
				</Grid>
			</div>
			<div>
				<br></br>
			</div>

			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={4}>
						<div className={classes.card}>
							<ToolTip text={'Cantidad de Scanits de Gastos Aprobados'} />
							<TotalScanits
								title={'Scanits Aprobados'}
								info={'(Gastos Aprobados)'}
								scanitData={scanitActualData}
								isLoading={isLoading}
							/>
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.card}>
							<ToolTip text={'Total de Scanits tomando en cuenta todos los gastos (Aprobados, Rechazados, Borrador)'} />
							<TotalScanits
								title={'Scanits Totales'}
								info={'(Todos los gastos)'}
								scanitData={totalScanitActualData}
								isLoading={isLoading}
							/>
						</div>
					</Grid>
					<Grid item xs={4}>
						<div className={classes.card}>
							<ToolTip text={'Accuracy de Scanit para el Mes del Segundo Filtro'} />
							<ScanitAccuracy title={'Scanits Totales'} info={'(Todos los gastos)'} scanitData={scanitAccuracy} isLoading={isLoading} />
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* Sección 2 */}
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div className={classes.card}>
							<div className={classes.barChartScanit}>
								<BarChartScanit
									title="Evolución Número de Scanits"
									dataApproved={scanitReportingData}
									dataTotalScanits={totalScanitsByMonth}
									initialDate={initialDate}
									endDate={endDate}
									isLoading={isLoading}
								/>
							</div>
						</div>
					</Grid>
				</Grid>
			</Grid>
		</Fragment>
	);
};

export default React.memo(withErrorHandler(Scanit, Axios));
